<template>
    <el-dialog :title="'产品详情-' + productInfo.name" :visible.sync="productDetailDialog" width="1200px" :before-close="handleDialogClose"  append-to-body :close-on-click-modal="false" class="custom-form-dialog custom-inventory-dialog">
        <div class="product_detail_wrap" v-loading="loading">
            <el-tabs v-model="activeName" @tab-click="handleClickTab" >
                <el-tab-pane  label="库存产品" name="1" >
                    <div class="product_detail_top">
                        <div class="search_left">
                            <el-input size="small" v-model="keywords" placeholder="请输入搜索内容"  clearable  @clear="handleClickSearch" @blur="handleClickSearch">
                                <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                            </el-input>
                            <el-popover placement="right-start" width="500" trigger="click" @hide="handleClickSearch">
                                <div class="search_container">
                                    <div class="search_top_container">
                                        <span class="title">筛选</span>
                                        <el-button @click="handleClickReset(1)" size="mini" :disabled="searchFilterList.findIndex(find => find.field_value) > -1 ? false : true">清空筛选条件</el-button>
                                    </div>
                                    <div class="search_bottom_container">
                                        <ul>
                                            <li v-for="item in searchFilterList">
                                                <div>
                                                    <el-select size="small" v-model="item.field_key" disabled>
                                                        <el-option label="入库类型" value="stock_type"></el-option>
                                                        <el-option label="处理人"   value="uid"></el-option>
                                                        <el-option label="单据日期" value="date_range"></el-option>
                                                    </el-select>
                                                </div>
                                                <div class="search_filter_type">
                                                    <el-select size="small" v-model="item.field_type" disabled>
                                                        <el-option label="满足" value="eq"></el-option>
                                                        <el-option label="不满足" value="neq"></el-option>
                                                    </el-select>
                                                </div>
                                                <div>
                                                    <template v-if="item.field_key == 'stock_type'">
                                                        <el-select clearable placeholder="请选择入库类型" size="small" v-model="item.field_value"  filterable remote reserve-keyword  >
                                                            <el-option :label="item.stock_type_name" :value="item.stock_type" v-for="item in inTypeList"></el-option>
                                                        </el-select>
                                                    </template>
                                                    <template v-if="item.field_key == 'uid'">
                                                        <el-select clearable placeholder="请选择处理人" size="small" v-model="item.field_value" filterable remote reserve-keyword  :remote-method="getUserList">
                                                            <el-option :label="item.name" :value="item.uid" v-for="item in userList"></el-option>

                                                        </el-select>
                                                    </template>
                                                    <template v-if="item.field_key == 'date_range'">
                                                        <el-date-picker  v-model="item.field_value" size="small"  format="yyyy-MM-dd" value-format="yyyy-MM-dd"  type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                                                    </template>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <el-button size="small" slot="reference" class="custom_popover_button">
                                    <i class="iconfont icon-shaixuan"></i>
                                    <span class="search_filter_length" v-if="searchFilterList.filter(find => isValid(find.field_value)).length">
                                    <span  v-text="searchFilterList.filter(find => isValid(find.field_value)).length + '个条件'"></span>
                                    <i class="el-icon-error" @click="handleClickReset(1)"></i>
                                </span>
                                </el-button>
                            </el-popover>
                        </div>
                    </div>
                    <div class="product_detail_bottom">
                        <el-table class="custom_table" :data="tableData" border height="438px" ref="multipleTable" row-key="id">
                            <el-table-column label="产品编码\数量" prop="name" show-overflow-tooltip width="178px">
                                <template slot-scope="{row}">
                                    <span v-if="row.code" v-text="row.code"></span>
                                    <span v-else>1</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="产品单价" prop="cost_price"  show-overflow-tooltip width="122px"></el-table-column>
                            <el-table-column label="入库类型" prop="stock_type_name"  show-overflow-tooltip width="180px"></el-table-column>
                            <el-table-column label="单据日期" prop="created_at"  show-overflow-tooltip width="136px"></el-table-column>
                            <el-table-column label="处理人" prop="name"  show-overflow-tooltip width="150px">
                                <template #default="{ row }">
                                    <userDetailPopover v-if="row.user" :uid="row.user.id">
                                        <div slot="container">
                                            <div class="user_head">
                                                <img :src="row.user.avatar ? row.user.avatar : defaultImg" alt="" />
                                                <span v-text="row.user.name"></span>
                                            </div>
                                        </div>
                                    </userDetailPopover>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" prop="note"  show-overflow-tooltip width="280px"></el-table-column>
                            <el-table-column label="产品状态" prop="status"  class-name=" tableInputColumn" show-overflow-tooltip >
                                <template slot-scope="{row}">
                                    <el-select size="small" :value="row.status">
                                        <el-option @click.native="handleChangeStatus(row,0)" label="正常" :value="0"></el-option>
                                        <el-option @click.native="handleChangeStatus(row,2)" label="报废" :value="2"></el-option>
                                        <el-option @click.native="handleChangeStatus(row,1)" label="丢失" :value="1"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
                <el-tab-pane  label="入库记录" name="2" >
                    <div class="product_detail_top">
                        <div class="search_left">
                            <el-input size="small" v-model="inKeywords" placeholder="请输入搜索内容"  clearable  @clear="handleClickSearch"  @blur="handleClickSearch">
                                <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                            </el-input>
                            <el-popover placement="right-start" width="500" trigger="click" @hide="handleClickSearch">
                                <div class="search_container">
                                    <div class="search_top_container">
                                        <span class="title">筛选</span>
                                        <el-button @click="handleClickReset(2)" size="mini" :disabled="inSearchFilterList.findIndex(find => find.field_value) > -1 ? false : true">清空筛选条件</el-button>
                                    </div>
                                    <div class="search_bottom_container">
                                        <ul>
                                            <li v-for="item in inSearchFilterList">
                                                <div>
                                                    <el-select size="small" v-model="item.field_key" disabled>
                                                        <el-option label="入库类型" value="stock_type"></el-option>
                                                        <el-option label="入库仓库"   value="stock_id"></el-option>
                                                        <el-option label="处理人"   value="uid"></el-option>
                                                        <el-option label="单据日期" value="date_range"></el-option>
                                                    </el-select>
                                                </div>
                                                <div class="search_filter_type">
                                                    <el-select size="small" v-model="item.field_type" disabled>
                                                        <el-option label="满足" value="eq"></el-option>
                                                        <el-option label="不满足" value="neq"></el-option>
                                                    </el-select>
                                                </div>
                                                <div>
                                                    <template v-if="item.field_key == 'stock_type'">
                                                        <el-select clearable placeholder="请选择入库类型" size="small" v-model="item.field_value"  filterable remote reserve-keyword  >
                                                            <el-option :label="item.stock_type_name" :value="item.stock_type" v-for="item in inTypeList"></el-option>
                                                        </el-select>
                                                    </template>
                                                    <template v-if="item.field_key == 'stock_id'">
                                                        <el-select clearable  placeholder="请选择入库仓库" size="small" v-model="item.field_value" >
                                                            <el-option :label="item.name" :value="item.id" v-for="item in stockList"></el-option>
                                                        </el-select>
                                                    </template>
                                                    <template v-if="item.field_key == 'uid'">
                                                        <el-select clearable placeholder="请选择处理人" size="small" v-model="item.field_value" filterable remote reserve-keyword  :remote-method="getUserList">
                                                            <el-option :label="item.name" :value="item.uid" v-for="item in userList"></el-option>

                                                        </el-select>
                                                    </template>
                                                    <template v-if="item.field_key == 'date_range'">
                                                        <el-date-picker  v-model="item.field_value" size="small"  format="yyyy-MM-dd" value-format="yyyy-MM-dd"  type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                                                    </template>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <el-button size="small" slot="reference" class="custom_popover_button">
                                    <i class="iconfont icon-shaixuan"></i>
                                    <span class="search_filter_length" v-if="inSearchFilterList.filter(find => isValid(find.field_value)).length">
                                    <span  v-text="inSearchFilterList.filter(find => isValid(find.field_value)).length + '个条件'"></span>
                                    <i class="el-icon-error" @click="handleClickReset(2)"></i>
                                </span>
                                </el-button>
                            </el-popover>
                        </div>
                    </div>
                    <div class="product_detail_bottom">
                        <el-table class="custom_table" :data="tableData" border height="438px" ref="inTable" row-key="id"  >
                            <el-table-column label="入库类型"  prop="stock_type_name" show-overflow-tooltip width="124px"></el-table-column>
                            <el-table-column label="入库单编号" prop="log_num"  show-overflow-tooltip width="162px">
                                <template slot-scope="{row}">
                                    <span class="link-label" v-text="row.log_num" @click="handleClickInDetail(row)"></span>
                                </template>
                            </el-table-column>
                            <el-table-column label="入库数量" prop="total_num" align="right" show-overflow-tooltip width="92px"></el-table-column>
                            <el-table-column label="入库日期" prop="created_at"  show-overflow-tooltip width="136px"></el-table-column>
                            <el-table-column label="处理人" prop="creator_info"  show-overflow-tooltip width="150px">
                                <template #default="{ row }">
                                    <userDetailPopover v-if="row.creator_info" :uid="row.creator_info.id">
                                        <div slot="container">
                                            <div class="user_head">
                                                <img :src="row.creator_info.avatar ? row.creator_info.avatar : defaultImg" alt="" />
                                                <span v-text="row.creator_info.name"></span>
                                            </div>
                                        </div>
                                    </userDetailPopover>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" prop="note"  show-overflow-tooltip ></el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
                <el-tab-pane  label="出库记录" name="3" >
                    <div class="product_detail_top">
                        <div class="search_left">
                            <el-input size="small" v-model="outKeywords" placeholder="请输入搜索内容"  clearable  @clear="handleClickSearch"  @blur="handleClickSearch">
                                <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                            </el-input>
                            <el-popover placement="right-start" width="500" trigger="click" @hide="handleClickSearch">
                                <div class="search_container">
                                    <div class="search_top_container">
                                        <span class="title">筛选</span>
                                        <el-button @click="handleClickReset(3)" size="mini" :disabled="outSearchFilterList.findIndex(find => find.field_value) > -1 ? false : true">清空筛选条件</el-button>
                                    </div>
                                    <div class="search_bottom_container">
                                        <ul>
                                            <li v-for="item in outSearchFilterList">
                                                <div>
                                                    <el-select size="small" v-model="item.field_key" disabled>
                                                        <el-option label="出库类型" value="stock_type"></el-option>
                                                        <el-option label="出库仓库" value="stock_id"></el-option>
                                                        <el-option label="处理人"   value="uid"></el-option>
                                                        <el-option label="单据日期" value="date_range"></el-option>
                                                    </el-select>
                                                </div>
                                                <div class="search_filter_type">
                                                    <el-select size="small" v-model="item.field_type" disabled>
                                                        <el-option label="满足" value="eq"></el-option>
                                                        <el-option label="不满足" value="neq"></el-option>
                                                    </el-select>
                                                </div>
                                                <div>
                                                    <template v-if="item.field_key == 'stock_type'">
                                                        <el-select clearable placeholder="请选择出库类型" size="small" v-model="item.field_value"  filterable remote reserve-keyword  >
                                                            <el-option :label="item.stock_type_name" :value="item.stock_type" v-for="item in outTypeList"></el-option>
                                                        </el-select>
                                                    </template>
                                                    <template v-if="item.field_key == 'stock_id'">
                                                        <el-select clearable  placeholder="请选择出库仓库" size="small" v-model="item.field_value" >
                                                            <el-option :label="item.name" :value="item.id" v-for="item in stockList"></el-option>
                                                        </el-select>
                                                    </template>
                                                    <template v-if="item.field_key == 'uid'">
                                                        <el-select clearable placeholder="请选择处理人" size="small" v-model="item.field_value" filterable remote reserve-keyword  :remote-method="getUserList">
                                                            <el-option :label="item.name" :value="item.uid" v-for="item in userList"></el-option>

                                                        </el-select>
                                                    </template>
                                                    <template v-if="item.field_key == 'date_range'">
                                                        <el-date-picker  v-model="item.field_value" size="small"  format="yyyy-MM-dd" value-format="yyyy-MM-dd"  type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                                                    </template>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <el-button size="small" slot="reference" class="custom_popover_button">
                                    <i class="iconfont icon-shaixuan"></i>
                                    <span class="search_filter_length" v-if="outSearchFilterList.filter(find => isValid(find.field_value)).length">
                                    <span  v-text="outSearchFilterList.filter(find => isValid(find.field_value)).length + '个条件'"></span>
                                    <i class="el-icon-error" @click="handleClickReset(3)"></i>
                                </span>
                                </el-button>
                            </el-popover>
                        </div>
                        <div class="handle_right">

                        </div>
                    </div>
                    <div class="product_detail_bottom">
                        <el-table class="custom_table" :data="tableData" border height="438px" ref="outTable" row-key="id"  >
                            <el-table-column label="出库类型"  prop="stock_type_name" show-overflow-tooltip width="124px"></el-table-column>
                            <el-table-column label="出库单编号" prop="log_num"  show-overflow-tooltip width="162px">
                                <template slot-scope="{row}">
                                    <span class="link-label" v-text="row.log_num" @click="handleClickOutDetail(row)"></span>
                                </template>
                            </el-table-column>
                            <el-table-column label="出库数量" prop="total_num" align="right" show-overflow-tooltip width="92px"></el-table-column>
                            <el-table-column label="出库日期" prop="created_at"  show-overflow-tooltip width="136px"></el-table-column>
                            <el-table-column label="处理人" prop="creator_info"  show-overflow-tooltip width="150px">
                                <template #default="{ row }">
                                    <userDetailPopover v-if="row.creator_info" :uid="row.creator_info.id">
                                        <div slot="container">
                                            <div class="user_head">
                                                <img :src="row.creator_info.avatar ? row.creator_info.avatar : defaultImg" alt="" />
                                                <span v-text="row.creator_info.name"></span>
                                            </div>
                                        </div>
                                    </userDetailPopover>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" prop="note"  show-overflow-tooltip ></el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div class="product_detail_pagination">
                <el-pagination background
                               size="mini"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="pagination.pageNum"
                               :page-sizes="pagination.pageSizes"
                               :page-size="pagination.pageSize"
                               :layout="pagination.layout"
                               :pager-count="5"
                               :total="pagination.total">
                </el-pagination>
            </div>
        </div>
        <InProductDetail :inProductDetailDialog.sync="inProductDetailDialog" v-if="inProductDetailDialog" :inColumnId="inColumnId"></InProductDetail>
        <OutProductDetail :outProductDetailDialog.sync="outProductDetailDialog" v-if="outProductDetailDialog" :outColumnId="outColumnId"></OutProductDetail>
    </el-dialog>
</template>
<script>
import { GetUserList,getStockType,stockProductDetails,stockList,stockProductDetailsInList,stockProductDetailsOutList ,stockEditProductStatus} from "@/api/index.js"
import {pagination} from '@/mixins'
import InProductDetail from "../../component/in_product_detail"
import OutProductDetail from "../../component/out_product_detail"
import userDetailPopover from "@/components/pComponents/userDetailPopover";

export default {
    name: "product_detail",
    props: {
        productDetailDialog: {
            type: Boolean,
            default: false
        },
        productInfo: {
            type: Object,
            default: () => {}
        },
    },
    components: {
        InProductDetail,
        OutProductDetail,
        userDetailPopover
    },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            loading:false,
            keywords:'',
            inKeywords:'',
            outKeywords:'',
            BtnDisabled:false,
            tableData:[],
            activeName:'1',
            searchFilterList:[
                {
                    field_key: 'stock_type',
                    field_name: '入库类型',
                    field_value: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'uid',
                    field_name: '处理人',
                    field_value: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'date_range',
                    field_name: '单据日期',
                    field_value: [],
                    field_type: 'eq',
                },
            ],
            inSearchFilterList:[
                {
                    field_key: 'stock_type',
                    field_name: '入库类型',
                    field_value: '',
                    field_type: 'eq',
                },
                // {
                //     field_key: 'stock_id',
                //     field_name: '入库仓库',
                //     field_value: '',
                //     field_type: 'eq',
                // },
                {
                    field_key: 'uid',
                    field_name: '处理人',
                    field_value: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'date_range',
                    field_name: '单据日期',
                    field_value: [],
                    field_type: 'eq',
                },
            ],
            outSearchFilterList:[
                {
                    field_key: 'stock_type',
                    field_name: '出库类型',
                    field_value: '',
                    field_type: 'eq',
                },
                // {
                //     field_key: 'stock_id',
                //     field_name: '出库仓库',
                //     field_value: '',
                //     field_type: 'eq',
                // },
                {
                    field_key: 'uid',
                    field_name: '处理人',
                    field_value: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'date_range',
                    field_name: '单据日期',
                    field_value: [],
                    field_type: 'eq',
                },
            ],
            inTypeList:[],
            stockList:[],
            outTypeList:[],
            userList:[],
            inProductDetailDialog:false,
            outProductDetailDialog:false,
            inColumnId:0,
            outColumnId:0
        }
    },
    mixins: [pagination],
    created() {
        console.log(this.productInfo)
        this.getInTypeList()
        this.getUserList()
        this.getTableData()

    },
    methods: {
        isValid(value){
            if (Array.isArray(value)) return value.length > 0
            if (typeof value === 'string') return value.trim() !== ''
            // 根据业务需求添加其他类型验证
            return (
                    value !== undefined &&
                    value !== null &&
                    value !== false &&
                    !Number.isNaN(value)
            )
        },
        handleClickTab(val){
            this.$nextTick(()=>{
                if(this.activeName == 1){
                    this.$refs.multipleTable.doLayout()
                }else if(this.activeName == 2){
                    this.$refs.inTable.doLayout()
                }else{
                 this.getOutTypeList()
                  this.$refs.outTable.doLayout()
                }
            })
            this.pagination.pageNum = 1
            if(this.stockList.length == 0){
                this.getStockList()
            }
            this.getTableData()
        },

        handleClickSearch(){
            this.pagination.pageNum = 1
            this.getTableData()
        },
        // 获取所有类型
        getInTypeList(){
            getStockType({ type:'in'}).then((res) => {
                if (res.code == 200) {
                    this.inTypeList = res.data || []
                }
            });
        },
        getOutTypeList(){
            getStockType({ type:'out'}).then((res) => {
                if (res.code == 200) {
                    this.outTypeList = res.data || []
                }
            });
        },
        // 获取仓库
        getStockList(){
            stockList({}).then(res => {
                if (res.code === 200) {
                    this.stockList = res.data
                }
            })
        },
        // 获取用户
        getUserList(keyword){
            GetUserList({ keyword }).then((res) => {
                if (res.code == 200) {
                    this.userList = res.data || [];
                }
            });
        },
        // 清空筛选条件
        handleClickReset(type){
            if(type == 1){
                this.searchFilterList = JSON.parse(JSON.stringify(this.$options.data().searchFilterList))
            }else if(type == 2){
                this.inSearchFilterList = JSON.parse(JSON.stringify(this.$options.data().inSearchFilterList))
            }else{
                this.outSearchFilterList = JSON.parse(JSON.stringify(this.$options.data().outSearchFilterList))
            }
        },

        handleSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val
            this.getTableData()
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getTableData()
        },
        getTableData(){
            if(this.activeName == 1){
                let postData = {
                    page:this.pagination.pageNum,
                    pageSize:this.pagination.pageSize,
                    keyword:this.keywords,
                    id:this.productInfo.id,
                    stock_id:this.productInfo.stock_id,
                }
                this.searchFilterList.forEach((item)=>{
                    if(item.field_key == 'date_range'){
                        if(item.field_value && item.field_value.length>0){
                            let startDate = item.field_value[0] + ' 00:00'
                            let endDate = item.field_value[1] + ' 23:59'
                            postData[item.field_key] = startDate + ' - ' + endDate
                        }else{
                            postData[item.field_key] = ''
                        }
                    }else{
                        postData[item.field_key] = item.field_value
                    }
                })
                this.loading = true
                stockProductDetails(postData).then(res => {
                    if (res.code === 200) {
                        const {list, total} = res.data
                        this.tableData = list
                        this.pagination.total = total
                    }
                    this.loading = false
                })
            }else if(this.activeName == 2){
                let postData = {
                    page:this.pagination.pageNum,
                    pageSize:this.pagination.pageSize,
                    keyword:this.inKeywords,

                    stock_id:this.productInfo.stock_id,
                    name:this.productInfo.name,
                    sku_id:this.productInfo.sku_id,
                    sku_key:this.productInfo.sku_key,
                }
                this.inSearchFilterList.forEach((item)=>{
                    if(item.field_key == 'date_range'){
                        if(item.field_value && item.field_value.length>0){
                            let startDate = item.field_value[0] + ' 00:00'
                            let endDate = item.field_value[1] + ' 23:59'
                            postData[item.field_key] = startDate + ' - ' + endDate
                        }else{
                            postData[item.field_key] = ''
                        }
                    }else{
                        postData[item.field_key] = item.field_value
                    }
                })
                this.loading = true
                stockProductDetailsInList(postData).then(res => {
                    if (res.code === 200) {
                        const {list, total} = res.data
                        this.tableData = list
                        this.pagination.total = total
                    }
                    this.loading = false
                })
            }else if(this.activeName == 3){
                let postData = {
                    page:this.pagination.pageNum,
                    pageSize:this.pagination.pageSize,
                    keyword:this.outKeywords,
                    stock_id:this.productInfo.stock_id,
                    name:this.productInfo.name,
                    sku_id:this.productInfo.sku_id,
                    sku_key:this.productInfo.sku_key,
                }
                this.outSearchFilterList.forEach((item)=>{
                    if(item.field_key == 'date_range'){
                        if(item.field_value && item.field_value.length>0){
                            let startDate = item.field_value[0] + ' 00:00'
                            let endDate = item.field_value[1] + ' 23:59'
                            postData[item.field_key] = startDate + ' - ' + endDate
                        }else{
                            postData[item.field_key] = ''
                        }
                    }else{
                        postData[item.field_key] = item.field_value
                    }
                })
                this.loading = true
                stockProductDetailsOutList(postData).then(res => {
                    if (res.code === 200) {
                        const {list, total} = res.data
                        this.tableData = list
                        this.pagination.total = total
                    }
                    this.loading = false
                })
            }
        },

        // 切换产品状态
        handleChangeStatus(row,value){
            console.log(row.status);
            console.log(value);
            if(value == 1){
                const h = this.$createElement;
                this.$msgbox({
                    title: '丢失',
                    message: h('div', null, [
                        h('span', null, '确定将此条数据更改为丢失状态吗, 是否继续?'),
                    ]),
                    iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                    customClass: 'prompt_message_custom',
                    confirmButtonText:   '是',
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    cancelButtonText:   '否',
                    showCancelButton: true,
                    confirmButtonClass: 'el-button--primary',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            done();
                        } else {
                            done();
                        }
                    }
                }).then(() => {
                    let postData = {
                        id:row.id,
                        status:value
                    }
                    stockEditProductStatus(postData).then(res => {
                        if (res.code === 200) {
                            this.getTableData()
                        }
                    })
                }).catch(() => {

                })
            }else if(value ==2){
                const h = this.$createElement;
                this.$msgbox({
                    title: '报废',
                    message: h('div', null, [
                        h('span', null, '确定将此条数据更改为报废状态吗, 是否继续?'),
                    ]),
                    iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                    customClass: 'prompt_message_custom',
                    confirmButtonText:   '是',
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    cancelButtonText:   '否',
                    showCancelButton: true,
                    confirmButtonClass: 'el-button--primary',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            done();
                        } else {
                            done();
                        }
                    }
                }).then(() => {
                    let postData = {
                        id:row.id,
                        status:value
                    }
                    stockEditProductStatus(postData).then(res => {
                        if (res.code === 200) {
                            this.getTableData()
                        }
                    })
                }).catch(() => {

                })
            }else{
                let postData = {
                    id:row.id,
                    status:value
                }
                stockEditProductStatus(postData).then(res => {
                    if (res.code === 200) {
                        this.getTableData()
                    }
                })
            }
        },
        // 入库单详情
        handleClickInDetail(row){
            this.inColumnId = row.id
            this.inProductDetailDialog = true
        },
        // 出库单详情
        handleClickOutDetail(row){
            this.outColumnId = row.id
            this.outProductDetailDialog = true
        },
        handleDialogClose() {
            this.$emit("update:productDetailDialog", false)
        },


    }
}
</script>
<style  lang="scss" scoped>
    @import "@/styles/inventory_management.scss";
</style>